export default __webpack_public_path__ + "static/media/mandalart_otani.1cb68312.jpeg";